<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
import Vue from "vue";
const customerId = window.localStorage.getItem("customerId");
export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "facilityRate",
        key: "id",
        url: {
          list: "/admin/system/facilityPay/list",
        },
        output: false,
        // order: "createTime",
      },
      query: {
        isClearFilterReset: true,
      },
      actions: [
        {
          label: "打印",
          // icon: "md-add",
          onClick: this.toAdd,
          type: "info",
          auth: "",
        },
      ],
      menus: [],
      filters: [
        {
          label: "使用部门",
          KeyEnter: this.search,
          name: "deskName",
          value: "",
          type: "input",
        },
        // // {
        // //   label: "负责人",
        // //   KeyEnter: this.search,
        // //   name: "maintainerId",
        // //   value: "",
        // //   type: "select",
        // //   dropList: [],
        // // },
        // {
        //   label: "安装时间",
        //   KeyEnter: this.search,
        //   name: "",
        //   value: "",
        //   type: "datetimerange",
        // },
      ],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "设备类型",
          key: "typeName",
          minWidth: 120,
          align: "left",
        },
        {
          title: "设备编号",
          key: "assetNum",
          minWidth: 120,
          align: "left",
        },
        {
          title: "型号",
          key: "facilityModel",
          minWidth: 120,
          align: "left",
        },
        {
          title: "使用部门",
          key: "deskName",
          minWidth: 120,
          align: "left",
        },
        {
          title: "安装/首盘时间",
          key: "installationTime",
          minWidth: 120,
          align: "left",
          sortable: true,
        },
        {
          title: "资产归属",
          key: "assetOwnership",
          minWidth: 180,
          align: "left",
        },
        {
          title: "本月费用",
          key: "serviceMoney",
          minWidth: 80,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.serviceMoney;
            return <span>{text}元</span>;
          },
        },
        {
          title: "是否本月安装",
          key: "nowMouthInstall",
          minWidth: 100,
          align: "left",
        },
        // {
        //   title: "盘点时间",
        //   key: "createTime",
        //   minWidth: 120,
        //   align: "left",
        // },
      ],
      inputValue: "",
      clickSelect: {},
    };
  },
  created() {
    let query = this.$route.query;
    this.query.customerId =
      Number(customerId) === 0
        ? window.localStorage.getItem("customerIdClick")
        : Number(customerId);
    this.query.begin = query.begin;
    this.query.end = query.end;
    if (Number(customerId) === 0) {
      this.tableCols.push({
        title: "操作",
        align: "center",
        width: 210,
        key: "handle",
        fixed: "right",
        handle: [
          (vm, h, currentRow, param) => {
            // let directives = []
            return (
              <Button
                size="small"
                onClick={() => this.toinfo(currentRow)}
                type="default"
                style={{
                  border: "none",
                  color: "#4991ff",
                  margin: "0",
                }}
              >
                编辑
              </Button>
            );
          },
        ],
        auth: {
          // edit: "system/knowledgeBaseTag/edit",
          // del: "system/inspection/delete",
        },
      });
    }
  },
  methods: {
    //查询维修员
    loaduserData() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load("/admin/system/maiUser/lista", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.nickName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "maintainerId") {
              // this.items[index]['dropList'] = dropList
              this.filters[index]["dropList"] = (
                this.filters[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    toAdd() {
      // $utils.url.push({ name: "edit_rate", query: { action: "add" } });
      let q = this.query;
      let customerNameStr =
        Number(customerId) === 0
          ? window.localStorage.getItem("customerNameClick")
          : window.localStorage.getItem("customerName");
      console.log(q);
      $utils.api.load("/admin/system/facilityPay/list", q, "get").then((res) => {
        console.log(res);
        let list = res.rows.map((item) => ({
          typeName: item.typeName ? item.typeName : "",
          facilityModel: item.facilityModel ? item.facilityModel : "",
          deskName: item.deskName ? item.deskName : "",
          installationTime: item.installationTime ? item.installationTime : "",
          assetOwnership: item.assetOwnership ? item.assetOwnership : "",
          assetNum: item.assetNum ? item.assetNum : "",
          serviceMoney: item.serviceMoney,
          nowMouthInstall: item.nowMouthInstall,
        }));
        if (res.code == 200) {
          printJS({
            printable: list,
            properties: [
              { field: "typeName", displayName: "设备类型" },
              { field: "assetNum", displayName: "设备编号" }, 
              { field: "facilityModel", displayName: "型号" },
              { field: "deskName", displayName: "使用部门" },
              { field: "installationTime", displayName: "安装/首盘时间" },
              { field: "assetOwnership", displayName: "资产归属" },
              { field: "serviceMoney", displayName: "本月费用（元）" },
              { field: "nowMouthInstall", displayName: "本月安装" }, 
            ],
            header: customerNameStr + " 收费明细表",
            headerStyle: `
                    font-weight:800;
                    font-size:18px;
                    text-align: center;
                    `,
            gridHeaderStyle: "border:none;text-align:left;",
            gridStyle: "border:none;white-space:nowrap !important;",
            style: `
                        th{
                        font-size:6px;
                        border-bottom: 1px solid #999 !important;
                        padding: 0px 5px;
                        }
                        td{
                        font-size:6px;
                        border-bottom: 1px solid #999 !important;
                        padding: 0px 5px;
                        }
                        td:nth-last-child(1){
                        text-align: center;
                        } 
                        th:nth-last-child(1){
                        text-align: center !important;
                        }
                        td:nth-last-child(2){
                        text-align: center;
                        } 
                        th:nth-last-child(2){
                        text-align: center !important;
                        }
                        `,

            type: "json",
          });
        }
      });
    },
    toinfo(row) {
      this.inputValue = row.serviceMoney;
      this.clickSelect = row;
      this.$Modal.success({
        closable: true,
        title: "操作",
        width: "800px",
        height: "900px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <div>
              <div>
                本月费用：
                <Input
                  vModel={this.inputValue}
                  placeholder="请输入本月费用"
                  style="width: 300px"
                />
              </div>
              <div style="margin-top:40px;width:100%;display:flex;justify-content:center;">
                <Button
                  size="large"
                  type="primary"
                  onClick={this.onInputClick.bind(this)}
                >
                  保存
                </Button>
              </div>
            </div>
          );
        },
      });
    },
    onInputClick() {
      let q = {
        id: this.clickSelect.id,
        serviceMoney: this.inputValue,
      };
      $utils.api.load("/admin/system/facilityPay/edit", q, "PUT").then((res) => {
        console.log(res);
        if (res.code == 200) {
          $utils.toast.success("修改成功！");
          this.$Modal.remove();
          this.search();
        }
      });
    },
  },
};
</script>
<style scoped></style>
